const translations = {
  "en": {
    "Failed to send verification code. Please try again.": "Failed to send verification code. Please try again.",
    "Invalid verification code. Please try again.": "Invalid verification code. Please try again.",
    "Please agree to the Privacy Policy first": "Please agree to the Privacy Policy first"
  },
  "zh-tw": {
    "Failed to send verification code. Please try again.": "無法傳送驗證碼。請再試一次。",
    "Invalid verification code. Please try again.": "驗證碼錯誤，請再試一次。",
    "Please agree to the Privacy Policy first": "請先同意隱私權政策"
  }
};

export default translations;
